import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import "./style.css";

export function HomeCarousel() {
  return (
    <div id="home" className="carousel_div">
      <Carousel
        className="carousel_class"
        showArrows={true} //是否展示左右箭头
        showStatus={false} //是否展示右上角状态
        showIndicators={true} // 是否展示指示器
        infiniteLoop={true} //时候循环
        autoPlay={true} //是否自动播放
        stopOnHover={true} // 鼠标放上去是否停止播放
        showThumbs={false} // 是否展示轮播缩放展示图
        useKeyboardArrows={false} // 是否使用键盘左右按钮滑动
        swipeable={false} // 是否刷新
        dynamicHeight={true} //动态高度
        emulateTouch={false} // 是否拖拽滑动>
      >
        {/* <div key="c1" className="mycarousel">
          <img src="./img/1.jpg" alt="MDA公司授权RADARSAT中国区总代理" />
        </div> */}
        <div key="c2" className="mycarousel">
          <img src="./img/2.jpg" alt="MDA公司授权RADARSAT中国区总代理" />
        </div>
        {/* <div key="c3" className="mycarousel">
          <img src="./img/3.jpg" alt="Planet卫星群产品中国区代理" />
        </div> */}
        <div key="c4" className="mycarousel">
          <img
            src="./img/4.jpg"
            alt="国内首个企业投资运营的德清卫星遥感地面接收站"
          />
        </div>
        <div key="c5" className="mycarousel">
          <img src="./img/5.jpg" alt="区域遥感" />
        </div>
      </Carousel>
    </div>
  );
}
